module.exports = __webpack_public_path__ + "static/ksasaki-00192370549118e48355f859afd40cee.png";